// src/components/layout/Header.js
import { Typography, Dropdown, Spin } from "antd";
import { DownOutlined, UserOutlined } from "@ant-design/icons";
import { NavLink, useHistory } from "react-router-dom";
import { useState, useEffect } from "react";
import { fetchUserDetails } from "../../pages/Dashboard/services/api";

const { Text } = Typography;

function Header({ name, subName, onPress }) {
  const history = useHistory();
  const [userData, setUserData] = useState({
    firstName: "",
    lastName: "",
    dealership: "",
    plan: "Pro",
    city: "",
    state: ""
  });
  const [loading, setLoading] = useState(true);

  // Fetch user details from GET /user/details – location (city, state) for top nav
  useEffect(() => {
    const getUserDetails = async () => {
      try {
        const data = await fetchUserDetails();
        const dealershipObj = data.dealership || {};
        const dealershipDetails = data.dealership_details || {};
        const dealershipName =
          typeof dealershipObj === "string"
            ? dealershipObj
            : dealershipObj.name || dealershipDetails.name || "";

        const city =
          data.dealership_city ||
          data.city ||
          dealershipObj.city ||
          dealershipDetails.city ||
          "";
        const state =
          data.dealership_state ||
          data.state ||
          dealershipObj.state ||
          dealershipDetails.state ||
          "";

        setUserData({
          firstName: data.first_name || "",
          lastName: data.last_name || "",
          dealership: dealershipName,
          plan: data.plan || "Pro",
          city,
          state
        });
      } catch (error) {
        console.error("Error fetching user details:", error);
      } finally {
        setLoading(false);
      }
    };

    getUserDetails();
  }, []);

  // Get dealer location (city, state) - always show as "City, State" format
  const dealerLocation = userData.city && userData.state 
    ? `${userData.city}, ${userData.state}`
    : userData.city 
    ? `${userData.city}`
    : userData.state
    ? userData.state
    : "Location";
  
  // Get dealership name for display
  const dealershipName = userData.dealership || "Dealership";

  // Logout handler using Clerk
  const handleLogout = () => {
    if (window.Clerk?.signOut) {
      window.Clerk.signOut();
    }
    history.push("/sign-in");
  };

  const profileDropdown = (
    <div className="profile-dropdown-menu">
      <div className="profile-dropdown-header">
        {loading ? (
          <div className="profile-dropdown-loading">
            <Spin size="small" />
            <span>Loading...</span>
          </div>
        ) : (
          <>
            <div className="profile-dropdown-header-text">
              <div className="profile-dropdown-name">{dealershipName}</div>
            </div>
            <DownOutlined className="profile-dropdown-chevron" />
          </>
        )}
      </div>
      <NavLink to="/profile" className="profile-dropdown-item" activeClassName="profile-dropdown-item-active">
        Account Settings
      </NavLink>
      <NavLink to="/billing" className="profile-dropdown-item" activeClassName="profile-dropdown-item-active">
        Billing & Plans
      </NavLink>
      <div className="profile-dropdown-divider" />
      <NavLink to="/support" className="profile-dropdown-item" activeClassName="profile-dropdown-item-active">
        Contact support
      </NavLink>
      <button type="button" className="profile-dropdown-signout" onClick={handleLogout}>
        Sign out
      </button>
    </div>
  );

  return (
    <div className="main-header">
      <div className="main-header__inner">
        {/* Left: Dealer location */}
        <div className="main-header__left">
          {loading ? (
            <Spin size="small" />
          ) : (
            <Text className="main-header__location">{dealerLocation}</Text>
          )}
        </div>

        {/* Right: Dealership name dropdown */}
        <div className="main-header__right">
          <Dropdown
            overlay={profileDropdown}
            trigger={["click"]}
            placement="bottomRight"
            overlayClassName="profile-dropdown-overlay"
          >
            <div className="main-header__dealership-dropdown" style={{ cursor: "pointer", display: "flex", alignItems: "center", gap: 8 }}>
              <UserOutlined className="main-header__profile-icon" />
              <Text className="main-header__dealership-text">{dealershipName}</Text>
              <DownOutlined className="main-header__dealership-chevron" />
            </div>
          </Dropdown>
        </div>
      </div>
    </div>
  );
}

export default Header;
